import { useEffect, useState } from 'react';
import { getDatabase, ref, get } from 'firebase/database';
import { BACKEND_INFO_PATH, BackendInfo, parseBackendInfo } from '../../utils/backendLevel';

export type BackendInfoState =
    | { status: 'loading' }
    | { status: 'error' }
    | { status: 'loaded'; info: BackendInfo | null };

/**
 * The deployed backend level (`global/backend`), read once. `info` is null when
 * the backend was deployed before the postdeploy hook existed.
 * Not read while `enabled` is false (the banner only checks for superadmins).
 */
export function useBackendInfo(enabled = true): BackendInfoState {
    const [state, setState] = useState<BackendInfoState>({ status: 'loading' });

    useEffect(() => {
        if (!enabled) return;
        let cancelled = false;
        get(ref(getDatabase(), BACKEND_INFO_PATH))
            .then(snapshot => {
                if (!cancelled) setState({ status: 'loaded', info: parseBackendInfo(snapshot.val()) });
            })
            .catch(error => {
                console.error('Error loading backend level:', error);
                if (!cancelled) setState({ status: 'error' });
            });
        return () => { cancelled = true; };
    }, [enabled]);

    return state;
}
